<template>
  <div>
    <div>
      <div
        class="title is-6 has-text-centered mb-5"
        v-html="
          $t(
            'first of all, lets take a picture of your face, read the following recomendations and press the button when youre ready'
          )
        "
      ></div>
      <!-- Contenedor relativo SOLO para el video y el overlay -->
      <div class="video-container">
        <video
          ref="video"
          autoplay
          playsinline
          class="video-element"
          @loadedmetadata="updateOverlaySize"
          @resize="updateOverlaySize"
        ></video>
        <!-- Overlay blanco con círculo transparente centrado SOLO sobre el video -->
        <div
          class="video-overlay"
          ref="overl"
          style="width: 100%; height: 100%"
        >
          <svg style="display: block; width: 100%; height: 100%">
            <defs>
              <mask id="mask">
                <rect :width="videoWidth" :height="videoHeight" fill="white" />
                <circle
                  :cx="videoWidth / 2"
                  :cy="videoHeight / 2"
                  :r="100"
                  fill="black"
                />
              </mask>
            </defs>
            <rect
              :width="videoWidth"
              :height="videoHeight"
              fill="rgba(20,22,26,0.9)"
              :mask="'url(#mask)'"
            />
            <circle
              :cx="videoWidth / 2"
              :cy="videoHeight / 2"
              :r="100"
              fill="none"
              stroke="#00d1b2"
              stroke-width="4"
            />
            <text
              :x="videoWidth / 2"
              :y="videoHeight / 2"
              text-anchor="middle"
              fill="#00d1b2"
              font-size="15"
              font-weight="bold"
              dy="7"
              style="user-select: none; opacity: 0.5"
            >
              {{ $t("place your face here") }}
            </text>
          </svg>
        </div>
      </div>
      <!-- El botón queda fuera del contenedor relativo, NO lo cubre el overlay -->
      <div
        class="button is-primary is-rounded is-fullwidth mt-5"
        style="z-index: 5"
        @click="take_picture"
      >
        <span class="icon">
          <i class="fa fa-camera"></i>
        </span>
        <span>{{ $t("take picture") }}</span>
      </div>
    </div>
    <div class="notification is-info mt-5">
      <div class="message-body">
        <ul>
          <li>{{ $t("make sure your face is well lit") }}</li>
          <li>
            {{
              $t(
                "avoid wearing any obstacles with your faces like hats, glasses or masks"
              )
            }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/utils";

export default {
  name: "Face",
  data() {
    return {
      retrived_verification_data: null,
      camera_devices: [],
      stream: null,
      videoWidth: 320,
      videoHeight: 240,
    };
  },
  methods: {
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: false,
        });
        this.$refs.video.srcObject = this.stream;
        // Espera a que el video tenga dimensiones reales
        this.$refs.video.onloadedmetadata = this.updateOverlaySize;
      } catch (e) {
        this.error = "No se pudo acceder a la cámara: " + e.message;
      }
    },
    updateOverlaySize() {
      // Actualiza el tamaño del overlay para que coincida con el video real
      if (this.$refs.video) {
        // this.videoWidth = this.$refs.video.videoWidth || 320;
        // this.videoHeight = this.$refs.video.videoHeight || 240;
        this.videoWidth = this.$refs.overl.offsetWidth || 320;
        this.videoHeight = this.$refs.overl.offsetHeight || 240;
      }
    },
    take_picture() {
      let v = this;
      const video = v.$refs.video;
      if (!video.srcObject) {
        v.$emit("error", v.$t("camera not started"));
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert the image to a data URL
      const dataURL = canvas.toDataURL("image/jpeg", 1);

      v.$root.loader(true);
      post("/identity/perform/face", {
        uuid: v.$route.params.uuid,
        image: dataURL,
      })
        .then((response) => {
          if (v.stream) {
            v.stream.getTracks().forEach((track) => track.stop());
          }
          v.$emit("success");
        })
        .catch((error) => {
          if (
            error.status === 404 &&
            error.data.includes("no face found on picture sent")
          ) {
            v.$emit("error", v.$t("no face found on picture sent"));
            return;
          }
          v.$emit("error", error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    start() {
      this.startCamera();
    },
  },
  mounted() {
    // this.startCamera();
  },
  beforeDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  aspect-ratio: 4/3;
}
.video-element {
  width: 100%;
  height: auto;
  border-radius: 8px;
  background: #000;
  display: block;
  aspect-ratio: 4/3;
}
.video-overlay {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  /* El tamaño lo controla el binding dinámico */
}
</style>
